import React,{useEffect} from 'react';
import './App.css';
import { Route, Routes, useLocation  } from "react-router-dom";
import Home from "./components/Home";
import Login from "./components/Login";
import { HttpService } from "./services/HttpService";
import ForgotPassword from "./components/ForgotPassword";
import { Suspense } from 'react';
import './i18n';
import "./loading.css";
import ResetPassword from './components/ResetPassword';
import Onboarding from './components/Onboarding';
import LostPhone from "./components/LostPhone";
import ResetDevice from "./components/ResetDevice";
import DownloadFile from "./components/DownloadFile";
import UnloggedHelpComponent from './components/help/UnloggedHelpComponent';
import PosnetApp from './components/PosnetApp';
HttpService.setupInterceptors()


function App() {   

  return (
      <Suspense fallback="...is loading">
          <Routes>
            <Route path={'/*'} element={<Home />} />
            <Route path={'/login'} element={<Login />} />
            <Route path={'/help-outside'} element={<UnloggedHelpComponent />} />
            <Route path={'/onboarding'} element={<Onboarding/>}/>
            <Route path={'/forgot-password'} element={<ForgotPassword />} />
            <Route path={'/lost-phone'} element={<LostPhone />} />
            <Route path={'/reset-password'} element={<ResetPassword />} />
            <Route path={'/download-file'} element={<DownloadFile />} />
            <Route path={'/reset-device'} element={<ResetDevice />} />
            <Route path={'/posnetApp'} element={<PosnetApp />} />
          </Routes>
      </Suspense>
  );
}

export default App;
